import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";

export interface ConfirmationDialogProps {
  onClose: (forceSave: boolean) => void;
  isOpen: boolean;
}

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { onClose, isOpen } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };

  return (
    <Dialog maxWidth="xs" open={isOpen}>
      <DialogTitle>Action required</DialogTitle>
      <DialogContent dividers>
        There are validation errors. Are you sure you want to continue?
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleCancel}
          color="primary"
          variant="contained"
        >
          No
        </Button>
        <Button onClick={handleOk} color="primary">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
